/**
 * @public
 */
export var Unit;
(function (Unit) {
    let Length;
    (function (Length) {
        function isRelative(unit) {
            return isFontRelative(unit) || isViewportRelative(unit);
        }
        Length.isRelative = isRelative;
        function isFontRelative(unit) {
            switch (unit) {
                case "em":
                case "ex":
                case "ch":
                case "rem":
                    return true;
            }
            return false;
        }
        Length.isFontRelative = isFontRelative;
        function isViewportRelative(unit) {
            switch (unit) {
                case "vw":
                case "vh":
                case "vmin":
                case "vmax":
                    return true;
            }
            return false;
        }
        Length.isViewportRelative = isViewportRelative;
        /**
         * {@link https://drafts.csswg.org/css-values/#lengths}
         */
        Length.Canonical = "px";
        function isCanonical(unit) {
            return unit === Length.Canonical;
        }
        Length.isCanonical = isCanonical;
        function isAbsolute(unit) {
            switch (unit) {
                case "cm":
                case "mm":
                case "Q":
                case "in":
                case "pc":
                case "pt":
                case "px":
                    return true;
            }
            return false;
        }
        Length.isAbsolute = isAbsolute;
    })(Length = Unit.Length || (Unit.Length = {}));
    Unit.isRelativeLength = Length.isRelative, Unit.isFontRelativeLength = Length.isFontRelative, Unit.isViewportRelativeLength = Length.isViewportRelative, Unit.isAbsoluteLength = Length.isAbsolute;
    function isLength(unit) {
        return Unit.isRelativeLength(unit) || Unit.isAbsoluteLength(unit);
    }
    Unit.isLength = isLength;
    let Angle;
    (function (Angle) {
        /**
         * {@link https://drafts.csswg.org/css-values/#angles}
         */
        Angle.Canonical = "deg";
        function isCanonical(unit) {
            return unit === Angle.Canonical;
        }
        Angle.isCanonical = isCanonical;
    })(Angle = Unit.Angle || (Unit.Angle = {}));
    function isAngle(unit) {
        switch (unit) {
            case "deg":
            case "grad":
            case "rad":
            case "turn":
                return true;
        }
        return false;
    }
    Unit.isAngle = isAngle;
    let Time;
    (function (Time) {
        /**
         * {@link https://drafts.csswg.org/css-values/#time}
         */
        Time.Canonical = "s";
        function isCanonical(unit) {
            return unit === Time.Canonical;
        }
        Time.isCanonical = isCanonical;
    })(Time = Unit.Time || (Unit.Time = {}));
    function isTime(unit) {
        switch (unit) {
            case "s":
            case "ms":
                return true;
        }
        return false;
    }
    Unit.isTime = isTime;
    let Frequency;
    (function (Frequency) {
        /**
         * {@link https://drafts.csswg.org/css-values/#frequency}
         */
        Frequency.Canonical = "hz";
        function isCanonical(unit) {
            return unit === Frequency.Canonical;
        }
        Frequency.isCanonical = isCanonical;
    })(Frequency = Unit.Frequency || (Unit.Frequency = {}));
    function isFrequency(unit) {
        switch (unit) {
            case "hz":
            case "kHz":
                return true;
        }
        return false;
    }
    Unit.isFrequency = isFrequency;
    let Resolution;
    (function (Resolution) {
        /**
         * {@link https://drafts.csswg.org/css-values/#resolution}
         */
        Resolution.Canonical = "dppx";
        function isCanonical(unit) {
            return unit === Resolution.Canonical;
        }
        Resolution.isCanonical = isCanonical;
    })(Resolution = Unit.Resolution || (Unit.Resolution = {}));
    function isResolution(unit) {
        switch (unit) {
            case "dpi":
            case "dpcm":
            case "dppx":
                return true;
        }
        return false;
    }
    Unit.isResolution = isResolution;
})(Unit || (Unit = {}));
//# sourceMappingURL=unit.js.map